export interface FormData {
	name: string;
	mobile: string;
	employeeCode: string;
	complaintDate: string;
	department: string;
	otherSpecify: string;
	productType: string;
	state: string;
	city: string;
	productName: string;
	customerType: string;
	address: string;
	sampleDate: string;
}

export interface ModalContent {
	loading: boolean;
	success: boolean;
}

export interface ContentVersionResponse {
	records: Array<{
		ContentDocumentId: string;
	}>;
}

export const DepartmentsObj: string[] = [
	'ARALDITE',
	'ASF - E-COMMERCE',
	'ASF - RETAIL',
	'ASF - SS',
	'ASF - TS',
	'CB-BD',
	'CC – MIDSIZE PROJECT',
	'CC - RETAIL',
	'CC–MIDSIZE PROJECT',
	'E-COMMERCE',
	'FV - BLUECOAT',
	'FV - F&B',
	'FV - FURNITUR CENTER',
	'FV - INSULATION IND',
	'FV - MINI INDUSTRY',
	'FV - PROJECT',
	'FV - RETAIL',
	'ICA PIL Retl Distrib',
	'INSTITUTIONAL BUSI',
	'JOINERY',
	'MNT - AUTO',
	'MNT - FMCG',
	'MNT - RETAIL',
	'MODERN TRADE',
	'MODERN TRADE (MT)',
	'ROFF - PROJECTS',
	'ROFF - RETAIL',
	'RURBAN',
	'SMALL TOWN INDIA',
	'Other (Please specify)',
];

export const StatesObj: string[] = [
	'Andhra Pradesh',
	'Arunachal Pradesh',
	'Assam',
	'Bihar',
	'Chhattisgarh',
	'Goa',
	'Gujarat',
	'Jharkhand',
	'Karnataka',
	'Madhya Pradesh',
	'Maharashtra',
	'Odisha',
	'Punjab',
	'Rajasthan',
	'Sikkim',
	'Tamil Nadu',
	'Telangana',
	'Tripura',
	'Uttar Pradesh',
	'Uttarakhand',
	'West Bengal',
	'Andaman and Nicobar Islands',
	'Chandigarh',
];

export const CustomerTypeObj: string[] = ['Retailer', 'Wholesaler', 'Manufacturer'];

export const ProductTypeObj: string[] = ['Counterfeit', 'Copycat'];
